import { login, logout, getInfo } from '@/services/user'
import { getLoginData, getToken, removeToken, setLoginData } from '@/utils/auth'
import router, { resetRouter } from '@/router'
const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ loginName: username.trim(), password: password }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token);
        if(!data.avastar || data.avastar=="1"){
          data.avastar="http://fnjkj.oss-cn-beijing.aliyuncs.com/images1/1567740082348.png";
        }
        setLoginData(data);
        commit('SET_NAME', data.userName)
        commit('SET_AVATAR', data.avastar)
        commit('SET_INTRODUCTION', false)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },


  // user login
  tokenLogin({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
       let  data  = userInfo;
        commit('SET_TOKEN', data.token);
        if(!data.avastar || data.avastar=="1"){
          data.avastar="http://fnjkj.oss-cn-beijing.aliyuncs.com/images1/1567740082348.png";
        }
        setLoginData(data);
        commit('SET_NAME', data.userName)
        commit('SET_AVATAR', data.avastar)
        commit('SET_INTRODUCTION', false)
        resolve()

    })
  },


  // get user info
  getInfo({ commit, state }) {
    let data= getLoginData();
    if(data){
      commit('SET_NAME', data.userName)
      commit('SET_AVATAR', data.avastar)
      commit('SET_INTRODUCTION', false)
    }

  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        resetRouter()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }



}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
